import styled from 'styled-components'

export const ContainerDoIcone = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  cursor: pointer;
`
